import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to console for debugging on mobile
    console.error("ErrorBoundary captured:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = "/panel";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4" data-testid="error-boundary">
          <div className="max-w-md w-full bg-white border border-stone-200 rounded-lg p-6 shadow-sm">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-red-600 text-2xl font-bold">!</span>
            </div>
            <h2 className="text-lg font-semibold text-stone-900 text-center mb-2">
              Algo salió mal
            </h2>
            <p className="text-sm text-stone-600 text-center mb-4">
              Encontramos un problema al mostrar esta sección. Tu información está segura.
            </p>
            {this.state.error?.message && (
              <pre className="text-xs text-stone-500 bg-stone-50 p-2 rounded mb-4 overflow-auto max-h-32">
                {String(this.state.error.message)}
              </pre>
            )}
            <div className="flex gap-2">
              <button
                onClick={this.handleReset}
                className="flex-1 px-4 py-2 bg-emerald-900 text-white rounded-lg text-sm font-medium hover:bg-emerald-800 active:bg-emerald-950 transition-colors"
                data-testid="btn-recargar-error"
              >
                Recargar
              </button>
              <button
                onClick={this.handleHome}
                className="flex-1 px-4 py-2 border border-stone-300 text-stone-700 rounded-lg text-sm font-medium hover:bg-stone-50 active:bg-stone-100 transition-colors"
                data-testid="btn-home-error"
              >
                Ir al panel
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
